export default __webpack_public_path__ + "static/media/free-astronaut.51342684.png";